export const PER_PAGE = 12;

export function mergeCollectionProducts(previous, incoming) {
  const prevEdges = previous?.products?.edges || [];
  const incomingEdges = incoming?.products?.edges || [];
  const seen = new Set(prevEdges.map((edge) => edge.cursor));
  const newEdges = incomingEdges.filter((edge) => !seen.has(edge.cursor));

  return {
    ...previous,
    ...incoming,
    products: {
      ...previous?.products,
      ...incoming?.products,
      edges: [...prevEdges, ...newEdges],
    },
  };
}

export class RelayConnection {
  constructor() {
    this.edges = [];
    this.pageInfo = {
      hasNextPage: false,
      hasPreviousPage: false,
      startCursor: null,
      endCursor: null,
    };
  }
}
